import React, { useMemo } from 'react';
import { Plus } from 'lucide-react';
import DayColumn from './DayColumn';
import { estimateMinutes } from '../WorkoutPlayer/playerLogic';
import './planStudio.css';

// O plano inteiro, em colunas de dias: o que se vê primeiro e onde se constrói. Os totais mostram o que o plano
// significa em tempo e volume, para se decidir sem contar à mão.

const asPlayerShape = (ex) => ({
  trackingType: ex.trackingType || 'weight-reps',
  prescription: {
    setsTarget: Number(ex.setsTarget) || null,
    repsMin: Number(ex.repsMin) || null,
    repsMax: Number(ex.repsMax) || null,
    restSeconds: Number(ex.restSeconds) || null,
  },
});

export default function PlanCanvas({
  days = [], narrow = false, editing = true, selectedPath, readOnly = false,
  onRenameDay, onSelectExercise, onFieldChange, onAddExercise, onRemoveExercise, onRemoveDay,
  onAddDay, onDropDay, onDragStartExercise, onReplace, onPreview,
}) {
  const totals = useMemo(() => {
    const exercises = days.flatMap((d) => d.exercises || []);
    const sets = exercises.reduce((n, e) => n + (Number(e.setsTarget) || 0), 0);
    const minutes = days.reduce((n, d) => {
      const list = (d.exercises || []).map(asPlayerShape);
      return n + (list.length === 0 ? 0 : estimateMinutes(list));
    }, 0);
    return { days: days.length, exercises: exercises.length, sets, minutes };
  }, [days]);

  // Ler só o que interessa quando o plano é de leitura: nada de controles que não fazem nada.
  const canEdit = editing && !readOnly;

  return (
    <div>
      <div className="ps-totals" data-testid="plan-totals">
        <span className="ps-total"><strong>{totals.days}</strong> {totals.days === 1 ? 'dia' : 'dias'}</span>
        <span className="ps-total"><strong>{totals.exercises}</strong> {totals.exercises === 1 ? 'exercício' : 'exercícios'}</span>
        <span className="ps-total"><strong>{totals.sets}</strong> séries</span>
        <span className="ps-total">~<strong>{totals.minutes}</strong> min por semana</span>
      </div>

      <div className={`ps-canvas ${narrow ? 'is-narrow' : ''}`} data-testid="plan-canvas">
        {days.map((day, dayIndex) => (
          <DayColumn
            key={dayIndex}
            day={day}
            dayIndex={dayIndex}
            narrow={narrow}
            editing={canEdit}
            selectedPath={selectedPath}
            onRenameDay={onRenameDay}
            onSelectExercise={onSelectExercise}
            onFieldChange={onFieldChange}
            onAddExercise={onAddExercise}
            onRemoveExercise={onRemoveExercise}
            onRemoveDay={onRemoveDay}
            onDropDay={onDropDay}
            onDragStartExercise={onDragStartExercise}
            onReplace={onReplace}
            onPreview={onPreview}
          />
        ))}

        {canEdit && onAddDay ? (
          <button type="button" className="ps-chip" style={{ alignSelf: 'start', padding: '10px 14px' }} onClick={onAddDay} data-testid="plan-add-day">
            <Plus size={14} aria-hidden="true" /> Adicionar dia
          </button>
        ) : null}
      </div>

      {days.length === 0 && canEdit ? <p className="ps-note">Ainda sem dias. Comece por «Adicionar dia» ou gere um plano.</p> : null}
    </div>
  );
}
